import { useRecoilValue } from "recoil";

import { viewDtosAtomFamily } from "@ryde/shared";

import { dashboardDefaultViewAppliedAtom } from "../dynamic-dashboard.atoms";
import { DASHBOARD_ENTITY } from "../dynamic-dashboard.models";
import { findDefaultView } from "./dashboard-views.utils";

/**
 * Whether the card layout is final: the views have loaded and, if one is the default, it has already
 * been applied over the seeded default cards.
 *
 * Anything deriving a request from the layout waits for this, or it asks for the seeded cards and then
 * asks again with the real set. It shares `findDefaultView` with the auto-apply step, so the gate and
 * that step cannot disagree about what "default" means.
 *
 * A failed views load resolves to `[]` rather than staying unresolved, so a server error degrades to
 * "no saved views" instead of a dashboard that never asks for data.
 */
export const useIsDashboardLayoutResolved = (): boolean => {
  const views = useRecoilValue(viewDtosAtomFamily(DASHBOARD_ENTITY));
  const isDefaultViewApplied = useRecoilValue(dashboardDefaultViewAppliedAtom);

  if (views === undefined) {
    return false;
  }

  return isDefaultViewApplied || !findDefaultView(views);
};
